import {
  ArrowRed,
  BestPerformingComponent,
  BestPerformingLocationsEntity,
  Div,
  H5,
  Icon,
  lightTheme,
  ModalPortal,
  P,
} from '@vgrubs/components';
import { useState } from 'react';

export const ActiveLocationsModal = ({
  title,
  list,
  listToCompare,
  isComparing,
}: {
  title: string;
  list?: BestPerformingLocationsEntity[];
  listToCompare?: BestPerformingLocationsEntity[];
  isComparing?: boolean;
}) => {
  const [isOpen, setIsOpen] = useState(false);

  const renderList = (items?: BestPerformingLocationsEntity[]) =>
    items && items.length > 0 ? (
      items.map((item, index) => (
        <BestPerformingComponent
          key={index}
          item={item}
          index={index}
          title={title}
          valueColor={lightTheme.blue}
          noTotalSales
          noLastActive
          noNumber
          link="/locations"
        />
      ))
    ) : (
      <Div $height="65px" $flex $alignCenter $center>
        <P $m="0">No Data Available.</P>
      </Div>
    );

  return (
    <>
      <Icon
        data-no-drag
        role="button"
        tabIndex={0}
        onPointerDown={(e) => e.stopPropagation()}
        $pointer
        onClick={() => setIsOpen(true)}
        color={lightTheme.lightGray}
      >
        <ArrowRed />
      </Icon>
      <ModalPortal
        isOpen={isOpen}
        closeModal={() => setIsOpen(false)}
        backgroundColor={lightTheme.white}
        padding="24px"
        logo={false}
        width="500px"
        maxHeight="calc(65px * 10)"
        modalOverflow="hidden"
        titleWithExit={title}
      >
        {isComparing ? (
          <>
            <H5 $mt="0" $mb="8">
              Selected Period
            </H5>
            {renderList(list)}
            <H5 $mb="8" $mt="24">
              Compared Period
            </H5>
            {renderList(listToCompare)}
          </>
        ) : (
          renderList(list)
        )}
      </ModalPortal>
    </>
  );
};
